import { Usuario } from "../Usuario/Usuario";

export class Alerta {
	public alertaId: number;
	public nombre: string;
	public descripcion: string;
	public umbralDias: number;
	public umbralCantidad: number;
	public requiereAccion: boolean;
	public activo: boolean;
	public usuarios: Usuario[];
	public usuariosAsignados: number;
	public configurable: boolean;
}
